import {Platform, StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {cloudLight, denim} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {
    paddingHorizontal: indent,
    borderColor: cloudLight,
    borderTopWidth: Platform.OS === 'web' ? 0 : 1,
    borderBottomWidth: 1,
    borderStyle: 'solid',
    marginTop: 15,
    paddingTop: 10,
    backgroundColor: 'white',
  },
  businessItem: {
    paddingVertical: 4,
  },
  labelContainer: {
    paddingVertical: 4,
  },
  labelTitle: {
    marginBottom: 4,
  },
  labelValue: {
    color: denim,
    fontWeight: '700',
    fontSize: 12,
  },
  healthCareProviderText: {
    marginBottom: 4,
  },
  healthCareProviderStatusText: {
    color: denim,
    fontWeight: '700',
    fontSize: 12,
  },
  supportedLanguageText: {
    marginBottom: 4,
  },
  supportedLanguageStatusText: {
    color: denim,
    fontWeight: '700',
    fontSize: 12,
  },
  leadsPoolOptionText: {
    marginBottom: 4,
  },
  leadStatusText: {
    color: denim,
    fontWeight: '700',
    fontSize: 12,
  },
});
